import { connect } from 'react-redux';

import { selectUserInfo, selectActiveVenueId, selectActiveClassId } from 'selectors/general';
import { selectLocaleData } from 'selectors/locale-data';

import { selectNavIsOpen, selectIsDesktop } from 'selectors/ui';
import { hideNavVisibility as hideNavVisibilityAction } from 'reducers/ui';

import { selectDesktopNavIsCollapsed } from './selectors';
import { toggleDesktopNavExpandCollapse as toggleDesktopNavExpandCollapseAction } from './saga';
import Sidenav from './Sidenav';

const mapStateToProps = state => {
  const user = selectUserInfo(state);
  const { isAuthenticated = false } = user;

  const activeVenueId = selectActiveVenueId(state);
  const activeClassId = selectActiveClassId(state);
  const { locale } = selectLocaleData(state);

  return {
    activeVenueId,
    activeClassId,
    isAuthenticated,
    isCollapsed: selectDesktopNavIsCollapsed(state) && selectIsDesktop(state),
    locale,
    mobileNavOpen: selectNavIsOpen(state),
    userInfo: user,
  };
};

const mapDispatchToProps = {
  hideNavVisibility: hideNavVisibilityAction,
  toggleDesktopNavExpandCollapse: toggleDesktopNavExpandCollapseAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidenav);
